import { format, subMonths } from "date-fns";
import { useEffect, useMemo } from "react";
import { useSearchParams } from "react-router-dom";

export const usePreviousMonth = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const previousMonth = useMemo(() => {
    return format(subMonths(new Date(), 1), "yyyy-MM");
  }, []);
  const reportMonth = searchParams.get("report_month");

  useEffect(() => {
    if (reportMonth) return;
    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        next.set("report_month", previousMonth);

        return next;
      },
      { replace: true },
    );
  }, [reportMonth, setSearchParams, previousMonth]);

  return reportMonth ?? previousMonth;
};
